import { render, staticRenderFns } from "./TripsArchived.vue?vue&type=template&id=295e4394"
import script from "./TripsArchived.vue?vue&type=script&lang=js"
export * from "./TripsArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports